import React, { useState, useRef } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import FormHeader from "../FormHeader";
import HandleError from "../../components/form/HandleError";
import { useNotification } from "../../contexts";
import { getImageUploadParams, addImage } from "../../services/files";
import { isFileTypeAccepted } from "../../utils";
import "./styles.css";

function ListingFileUpload(props) {
  const { photoUrls, onChange } = props;
  const [isActive, setIsActive] = useState(false);
  const { dispatch } = useNotification();

  const handleFileChange = (file) => {
    getImageUploadParams().then((config) => {
      const formData = new FormData();
      Object.keys(config.postParameters).forEach((key) => {
        formData.append(key, config.postParameters[key]);
      });
      formData.append("content-type", "image/png");
      formData.append("file", file);

      addImage(config.uploadUrl, formData).then((data) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, "text/xml");
        const x = xmlDoc.getElementsByTagName("Location")[0];
        const y = x.childNodes[0];
        onChange([...photoUrls, y.nodeValue]);
      });
    });
  };

  const removeUrl = (index) => () => {
    onChange([...photoUrls.slice(0, index), ...photoUrls.slice(index + 1)]);
  };

  const addFile = (file) => {
    if (isFileTypeAccepted(file.type)) {
      handleFileChange(file);
    } else {
      dispatch({
        type: "add",
        notifications: [{ type: "error", title: "Accept only PNG, JPG & GIF" }],
      });
    }
  };

  const onDrop = (event) => {
    event.preventDefault();
    if (event.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (var i = 0; i < event.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them
        if (event.dataTransfer.items[i].kind === "file") {
          const file = event.dataTransfer.items[i].getAsFile();
          addFile(file);
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (var i = 0; i < event.dataTransfer.files.length; i++) {
        const file = event.dataTransfer.files[i];
        addFile(file);
      }
    }
  };

  const onChangeFileInput = (event) => {
    const files = Array.from(event.target.files);
    addFile(files[0]);
  };

  const onDragOver = (event) => {
    event.preventDefault();
    setIsActive(true);
  };

  const onDragLeave = (event) => {
    event.preventDefault();
    setIsActive(false);
  };
  const inputFileRef = useRef(null);
  const onClick = (event) => {
    inputFileRef.current.click();
  };

  return (
    <Paper
      sx={{ padding: "2rem", marginBottom: "1rem" }}
      className="listing-file-upload"
    >
      <FormHeader title="Add photos" description="" />
      <div
        onDrop={onDrop}
        onDragOver={onDragOver}
        // onDragEnter={dragEnter}
        onDragLeave={onDragLeave}
        className={`drop-zone ${isActive ? "active" : ""}`}
        onClick={onClick}
      >
        <input
          type="file"
          ref={inputFileRef}
          onChange={onChangeFileInput}
          style={{ display: "none" }}
        />
        Add Photo
      </div>
      <HandleError name={`photoUrls`} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
        }}
      >
        {photoUrls.map((photo, index) => (
          <Box
            sx={{
              backgroundImage: `url(${photo})`,
            }}
            key={index}
            className="thumb"
          >
            <button onClick={removeUrl(index)}>X</button>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}

export default ListingFileUpload;
